import type { DefaultResponseBody, SearchParams, SearchResult } from "@gerama/types";
import type { ApiClient } from "../client";

/** Id lists go over the wire comma-separated (`categoryIds=1,2`), which `SearchQueryDto` parses. */
export function toSearchQuery(params: SearchParams) {
  const { categoryIds, artistIds, ...rest } = params;
  return {
    ...rest,
    q: params.q?.trim() || undefined,
    categoryIds: categoryIds?.length ? categoryIds.join(",") : undefined,
    artistIds: artistIds?.length ? artistIds.join(",") : undefined,
  };
}

export function createCoreSearchApi(client: ApiClient) {
  return {
    search: (params: SearchParams, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<SearchResult>>("/search", {
          query: toSearchQuery(params),
          signal,
        })
        .then((res) => res.data as SearchResult),
  };
}
